const features = [
  {
    image: '/images/mulai-investasi/feature1.png',
    title: 'Platform Charting Modern',
    desc: 'Tingkatkan analisis teknikal Anda dengan fitur charting canggih. Dilengkapi live price data dan ratusan indikator yang siap dipakai untuk membantu Anda mengambil keputusan trading.',
  },
  {
    image: '/images/mulai-investasi/feature2.png',
    title: 'Screener Terbaik',
    desc: 'Cari dan pilih saham sesuai dengan kriteria yang Anda inginkan. Buat sendiri aturan screening dengan ratusan kriteria yang tersedia atau gunakan langsung preset screener dengan kriteria para <i>guru</i> saham terkenal.',
  },
  {
    image: '/images/mulai-investasi/feature3.png',
    title: 'Data Finansial yang Lengkap',
    desc: 'Disajikan dalam berbagai jenis periode dengan data historikal hingga lebih dari 10 tahun. Dilengkapi dengan rasio-rasio keuangan dan data yang akurat dan terpercaya langsung dari sumber resmi.',
  },
  {
    image: '/images/mulai-investasi/feature4.png',
    title: 'PE Standard Deviation Band',
    desc: 'Tools canggih yang sering digunakan oleh institusi dan pemain besar untuk mengetahui apakah suatu saham masih murah atau sudah mahal secara cepat dan mudah.',
  },
];

export default features;
